import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useMutation, gql } from '@apollo/client'
import Template from '../../../components/Template'
import {
  openValidationPopup,
  openErrorPopup,
} from '../../../components/ConfirmationPopups'
import FicheForm from '../components/FicheForm'
import { button } from '../../../styles/button'

const FICHE_COMPARATIVE_CREATE = gql`
  mutation createFicheComparative(
    $countryConfigId: Int!
    $metaTitle: String!
    $metaDescription: String
    $comparativeChart: FicheComponentInput
    $customerReviews: FicheComponentInput
    $mainTitle: FicheComponentInput
    $illustratedTexts: FicheComponentInput
    $nextStep: FicheComponentInput
  ) {
    createFicheComparative(
      countryConfigId: $countryConfigId
      metaTitle: $metaTitle
      metaDescription: $metaDescription
      comparativeChart: $comparativeChart
      customerReviews: $customerReviews
      mainTitle: $mainTitle
      illustratedTexts: $illustratedTexts
      nextStep: $nextStep
    ) {
      ficheComparative {
        id
      }
    }
  }
`

const Create = (): JSX.Element => {
  return (
    <Template>
      <FicheComparativeCreate />
    </Template>
  )
}

const FicheComparativeCreate = (): JSX.Element => {
  const { t } = useTranslation()

  const [ficheComparativeCreate] = useMutation(FICHE_COMPARATIVE_CREATE)

  const onSubmit = (values: any) => {
    ficheComparativeCreate({
      variables: { ...values },
    })
      .then(() => {
        openValidationPopup(
          t('ficheComparative.successTitle'),
          t('ficheComparative.create.successDescription')
        )
        window.location.href = '/admin2/admin/fiche/comparatives'
      })
      .catch(e => openErrorPopup(t('ficheComparative.errorTitle'), e.message))
  }

  return (
    <Wrapper>
      <FicheForm onSubmit={onSubmit} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: #ffffff;
  display: block;
  width: 100%;
  padding: 15px;

  h4 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 16px;
  }

  .page-content {
    background: white !important;
  }

  ${button}
`

export default Create
